export const VERSION = '0.5.1';
//# sourceMappingURL=version.js.map